import type { IRecipient } from "@complex/SendMailModal/type";
import { Stack, Typography } from "@mui/material";
import type { CreateAction } from "@root/utils/enums/communication";
import type { Dispatch, SetStateAction } from "react";
import { CoachingStepChange } from "./coachingStep";
import { RecipientRow } from "./recipientRow";

interface ISendMailModalRecipientsBodyProps {
  recipients: IRecipient[];
  setRecipients: Dispatch<SetStateAction<IRecipient[]>>;
  coachingStepChange: string | undefined;
  setCoachingStepChange: Dispatch<SetStateAction<string | undefined>>;
  createAction: CreateAction;
  setCreateAction: Dispatch<SetStateAction<CreateAction>>;
  invalidRecipientsCount: number;
}

export const SendMailModalRecipientsBody = ({
  recipients,
  setRecipients,
  coachingStepChange,
  setCoachingStepChange,
  createAction,
  setCreateAction,
  invalidRecipientsCount,
}: ISendMailModalRecipientsBodyProps) => {
  return (
    <>
      {invalidRecipientsCount > 0 && (
        <Typography color="secondary">
          {invalidRecipientsCount}{" "}
          {invalidRecipientsCount > 1 ? "candidats sélectionnés ont" : "candidat sélectionné a"} une adresse invalide ou
          incomplète. Le courrier ne pourra pas leur être envoyé.
        </Typography>
      )}
      <Stack
        sx={{
          gap: 4,
        }}
      >
        <Stack
          sx={{
            gap: 2,
          }}
        >
          <Typography variant="subtitle1SemiBold" color="primary">
            Vérifier les adresses des destinataires
          </Typography>
          <Stack
            sx={{
              maxHeight: 250,
              pr: 2,
              overflowY: "auto",
            }}
          >
            {recipients.map((recipient, index) => (
              <RecipientRow
                key={recipient.candidate._id}
                recipient={recipient}
                removeRecipient={() =>
                  setRecipients((recipients) => {
                    const newRecipients = [...recipients];
                    newRecipients.splice(index, 1);
                    return newRecipients;
                  })
                }
              />
            ))}
          </Stack>
        </Stack>
        <CoachingStepChange
          coachingStepChange={coachingStepChange}
          setCoachingStepChange={setCoachingStepChange}
          createAction={createAction}
          setCreateAction={setCreateAction}
        />
      </Stack>
    </>
  );
};
